export default "__VITE_ASSET__BBR9_PX$__"